import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createNotificationApi, getAnnouncementsApi, getNotificationsApi, getSponsorNotificationsApi } from "./notificationApi";

export const getNotifications = createAsyncThunk(
  "notification/getNotifications",
  async ({ page, limit, isSponsor }, thunkAPI) => {
    try {
      const res = isSponsor
        ? await getSponsorNotificationsApi(page, limit)
        : await getNotificationsApi(page, limit);

      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const createNotification = createAsyncThunk(
  "notification/createNotification",
  async (data, thunkAPI) => {
    try {
      const res = await createNotificationApi(data);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

export const getAnnouncements = createAsyncThunk(
  "announcement/getAnnouncements",
  async ({ page, limit }, thunkAPI) => {
    try {
      const res = await getAnnouncementsApi(page, limit);
      return res.data.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err.response?.data);
    }
  }
);

const notificationSlice = createSlice({
  name: "notification",

  initialState: {
    notifications: [],
    announcements: [],
    loading: false,
    error: null,
  },

  reducers: {},

  extraReducers: (builder) => {

    builder
      .addCase(getNotifications.pending, (state) => {
        state.loading = true;
      })

      .addCase(getNotifications.fulfilled, (state, action) => {
        state.loading = false;
        state.notifications = action.payload.items || [];
      })

      .addCase(getNotifications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
    builder
      .addCase(getAnnouncements.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAnnouncements.fulfilled, (state, action) => {
        state.loading = false;
        state.announcements = action.payload.items || [];
      })
      .addCase(getAnnouncements.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });

    builder.addCase(createNotification.fulfilled, (state, action) => {
      state.notifications.unshift(action.payload);
    });

  },
});

export default notificationSlice.reducer;